<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-breadcrumbs
          class="pl-0 ml-0"
          :items="breadcrumbs"
          divider=">"
        ></v-breadcrumbs>
      </v-col>
      <v-col cols="12">
        <h1>Your experience</h1>
      </v-col>

      <v-col cols="12">
        <p>
          Please share your past or current roles where you've interacted with
          resumes - this could include positions in hiring, recruiting,
          management etc. Note that we are looking for a variety of roles and
          companies across the tech sector - whether you worked for a startup or
          a big tech company, we will be happy to have you on board!
        </p>
        <a @click="dialogHowVerify = true">How do we verify our reviewers?</a>
      </v-col>
      <v-col cols="12"><h3>Your experience</h3> </v-col>

      <v-row>
        <v-col cols="12" v-if="initialLoading">
          <v-timeline :dense="$vuetify.breakpoint.smAndDown">
            <v-timeline-item small color="grey">
              <v-skeleton-loader
                type="card"
                max-height="100"
              ></v-skeleton-loader>
            </v-timeline-item>
            <v-timeline-item small color="grey">
              <v-skeleton-loader
                type="card"
                max-height="100"
              ></v-skeleton-loader>
            </v-timeline-item>
          </v-timeline>
        </v-col>
        <v-col cols="12" v-if="!initialLoading" class="mb-3">
          <v-timeline :dense="$vuetify.breakpoint.smAndDown">
            <v-timeline-item v-for="exp in expArr" v-bind:key="exp.id" small>
              <v-card>
                <v-app-bar flat color="transparent">
                  <v-toolbar-title>{{ getCompanyName(exp) }}</v-toolbar-title>
                  <v-chip small outlined class="ml-2">
                    {{ exp.isVerified ? "Verified" : "Awaiting verification" }}
                  </v-chip>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="editExperience(exp.id)">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn icon @click="deleteExperience(exp.id)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-app-bar>
                <v-card-subtitle class="pt-1 pb-2">
                  {{ exp.startDate }} -
                  {{ exp.isCurrent ? "Now" : exp.endDate }}
                </v-card-subtitle>
                <v-card-text>
                  <v-chip
                    v-for="role in exp.selRoles"
                    :key="role"
                    class="mr-2"
                    outlined
                  >
                    {{ role }}
                  </v-chip>
                </v-card-text>
              </v-card>
            </v-timeline-item>
            <v-timeline-item color="grey" small>
              <v-btn text color="primary" @click="dialogAddExperience = true">
                Add experience
              </v-btn>
            </v-timeline-item>
          </v-timeline>
        </v-col>
        <v-col cols="12" class="ma-0 pa-0" v-if="errorMsg != ''">
          <v-alert dense outlined text type="error" class="ma-0">{{
            errorMsg
          }}</v-alert>
        </v-col>

        <v-col cols="12" class="d-flex">
          <v-spacer></v-spacer>
          <v-form>
            <v-btn
              color="primary"
              class="mr-2 mb-3"
              to="/reviewer-enrollment/step2?chained=true"
              v-if="chained"
            >
              Next step - linkedin account
            </v-btn>
            <v-btn
              color="primary"
              class="mr-2 mb-3"
              to="/settings"
              v-if="!chained"
            >
              Done - back to settings
            </v-btn>
          </v-form>
        </v-col>
      </v-row>

      <!-- dialog - how do we verify reviewers -->
      <v-dialog scrollable v-model="dialogHowVerify" width="70vw" height="60vh">
        <v-card>
          <v-card-title class="text-h5">
            How do we verify reviewers?
          </v-card-title>
          <v-card-text>
            Lorem ipsum dolor sit amet, semper quis, sapien id natoque elit.
            Nostra urna at, magna at neque sed sed ante imperdiet, dolor mauris
            cursus velit, velit non, sem nec. Volutpat sem ridiculus placerat
            leo, augue in, duis erat proin condimentum in a eget, sed fermentum
            sed vestibulum varius ac, vestibulum volutpat orci ut elit eget
            tortor. Ultrices nascetur nulla gravida ante arcu. Pharetra rhoncus
            morbi ipsum, nunc tempor debitis, ipsum pellentesque, vitae id quam
            ut mauris dui tempor, aptent non. Quisque turpis. Phasellus quis
            lectus luctus orci eget rhoncus. Amet donec vestibulum mattis
            commodo, nulla aliquet, nibh praesent, elementum nulla. Sit lacus
            pharetra tempus magna neque pellentesque, nulla vel erat. Justo ex
            quisque nulla accusamus venenatis, sed quis. Nibh phasellus gravida
            metus in, fusce aenean ut erat commodo eros. Ut turpis, dui integer,
            nonummy pede placeat nec in sit leo. Faucibus porttitor illo taciti
            odio, amet viverra scelerisque quis quis et tortor, curabitur morbi
            a. Enim tempor at, rutrum elit condimentum, amet rutrum vitae tempor
            torquent nunc. Praesent vestibulum integer maxime felis. Neque
            aenean quia vitae nostra, tempus elit enim id dui, at egestas
            pulvinar.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialogHowVerify = false">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- dialog - add experience -->
      <v-dialog
        scrollable
        v-model="dialogAddExperience"
        max-width="70vw"
        max-height="60vh"
        @click:outside="cancelAddExperience()"
        :disabled="addExperienceBtnLoading"
      >
        <v-card
          :loading="addExperienceBtnLoading"
          :disabled="addExperienceBtnLoading"
        >
          <v-card-title>Add experience</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" lg="3" md="6">
                <v-combobox
                  clearable
                  v-model="experience.selCompany"
                  :items="available_companies"
                  item-text="Name"
                  item-value="Id"
                  label="Select company"
                >
                </v-combobox>
              </v-col>
              <v-col
                cols="12"
                lg="3"
                md="6"
                v-if="
                  experience.selCompany != null &&
                  experience.selCompany?.Name == otherCompanyName
                "
              >
                <v-text-field
                  clearable
                  v-model="experience.manualCompanyName"
                  label="Company name"
                >
                </v-text-field>
              </v-col>
              <v-col
                cols="12"
                lg="3"
                md="6"
                v-if="experience.selCompany?.Name == otherCompanyName"
              >
                <v-text-field
                  clearable
                  v-model="experience.manualCompanyWebsite"
                  label="Company website"
                >
                </v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" lg="3" md="4">
                <v-combobox
                  clearable
                  multiple
                  v-model="experience.selRoles"
                  :items="available_roles"
                  label="Your role(s)"
                ></v-combobox>
              </v-col>
              <v-col cols="6" lg="2" md="4">
                <v-menu
                  ref="menuStart"
                  v-model="experience.menuStart"
                  :close-on-content-click="true"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="experience.startDate"
                      label="Start date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="experience.startDate"
                    type="month"
                    no-title
                    scrollable
                    :max="new Date().toISOString().substr(0, 7)"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="6" lg="2" md="4">
                <v-menu
                  ref="menuEnd"
                  v-model="experience.menuEnd"
                  :close-on-content-click="true"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :disabled="experience.isCurrent"
                      v-model="experience.endDate"
                      label="End date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    >
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="experience.endDate"
                    type="month"
                    no-title
                    scrollable
                    :min="experience.startDate"
                    :max="new Date().toISOString().substr(0, 7)"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" lg="2" md="4">
                <v-checkbox
                  v-model="experience.isCurrent"
                  label="Current job"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="cancelAddExperience()"
              :disabled="addExperienceBtnLoading"
            >
              Cancel
            </v-btn>
            <v-btn
              color="primary"
              :disabled="addExperienceBtnLoading"
              :loading="addExperienceBtnLoading"
              text
              @click="addOrUpdateExperience()"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      initialLoading: true,
      chained: false,
      dialogHowVerify: false,
      dialogAddExperience: false,
      experience: {
        id: -1,
        menuStart: false,
        menuEnd: false,
        startDate: null,
        endDate: null,
        isCurrent: false,
        selCompany: null,
        manualCompanyName: "",
        manualCompanyWebsite: "",
        selRoles: [],
      },
      expArr: [],
      available_companies: [],
      available_roles: ["Recruiter", "Manager", "Team lead", "Other"],
      otherCompanyName: "--- Other company ---",
      showLoading: false, //loading for setExperience
      errorMsg: "",
      addExperienceBtnLoading: false,
      breadcrumbs: [
        {
          text: "Settings",
          disabled: false,
          href: "/settings",
        },
        {
          text: "Reviewer enrollment - experience",
          disabled: true,
          href: "/reviewer-enrollment/step1",
        },
      ],
    };
  },
  mounted() {
    this.$utils.visit(this);
    console.log(this.$route.query.chained);
    if (this.$route.query.chained == "true") {
      this.chained = true;
    }
    this.getCompanies();
    this.getExperience();
  },
  methods: {
    addAnotherExp() {
      var newExp = { ...this.experience };
      newExp.id = this.expArr.length;
      this.expArr.push(newExp);
    },
    removeExp(id) {
      this.expArr.splice(id, 1);
      // fixing indexes
      for (let i = 0; i < this.expArr.length; i++) {
        this.expArr[i].id = i;
      }
    },
    getCompanies() {
      console.log("getCompanies()");
      this.errorMsg = "";
      // getting list of supported companies
      this.$http
        .post(this.$consts.BE_ADDRESS + "/pub/getAllCompanies")
        .then((response) => {
          if (response.status === 200) {
            for (let i = 0; i < response.data.length; i++) {
              this.available_companies.push(response.data[i]);
            }
            // add special option "Other company"
            this.available_companies.push({
              Id: "",
              Name: this.otherCompanyName,
            });
            return;
          }
          this.$utils.handleKnownRespCodes(this, response.status);
        })
        .catch((error) => {
          this.$utils.handleBackendError(this, error);
          this.errorMsg = this.$utils.getErrorMsg(error);
        });
    },
    getExperience() {
      console.log("getExperience()");
      // getting user experience
      this.errorMsg = "";
      this.$http
        .post(
          this.$consts.BE_ADDRESS + "/api/getExperience",
          {
            dusi: this.$store.getters.getDusi,
          },
          {
            headers: {
              Authorization: this.$store.state.token,
            },
          }
        )
        .then((response) => {
          if (response.status === 200) {
            if (response.data.experience != "") {
              this.expArr = JSON.parse(response.data.experience);
              console.log(JSON.stringify(this.expArr));
            }
            return;
          }
          this.$utils.handleKnownRespCodes(this, response.status);
        })
        .catch((error) => {
          this.$utils.handleBackendError(this, error);
          this.errorMsg = this.$utils.getErrorMsg(error);
        })
        .finally(() => {
          this.initialLoading = false;
        });
    },
    async setExperience() {
      this.errorMsg = "";
      try {
        await this.$utils.callBackendPost(this, "/api/setExperience", {
          experience: JSON.stringify(this.expArr),
        });
      } catch (error) {
        this.errorMsg = error;
      }
    },
    async addOrUpdateExperience() {
      try {
        console.log("addOrUpdateExperience()");
        this.addExperienceBtnLoading = true;
        // If we are adding a new entry id will be -1
        if (this.experience.id === -1) {
          console.log("adding new experience");
          // new experience entry needs to be verified
          this.experience.isVerified = false;
          this.addToExpArr(this.experience);
        } else {
          // otherwise it should be already updated
        }
        if (this.experience.selCompany.Name === this.otherCompanyName) {
          this.experience.selCompany = null;
        }
        this.organizeExpArr();
        await this.setExperience();
        if (this.errorMsg !== "") {
          this.expArr = [];
          await this.getExperience();
          return;
        }
        console.log(
          "after addOrUpdateExperience: " + JSON.stringify(this.expArr)
        );
      } catch (error) {
        this.errorMsg = this.$utils.getErrorMsg(error);
      } finally {
        this.clearCurExperience();
        this.dialogAddExperience = false;
        this.addExperienceBtnLoading = false;
      }
    },
    cancelAddExperience() {
      this.clearCurExperience();
      this.dialogAddExperience = false;
    },
    clearCurExperience() {
      this.experience = {
        id: -1,
        selCompany: null,
        manualCompanyName: "",
        manualCompanyWebsite: "",
        selRoles: [],
        startDate: null,
        endDate: null,
        isCurrent: false,
      };
    },
    addToExpArr(exp) {
      console.log("addToExpArr()");
      // we sort by starting date
      for (let i = 0; i < this.expArr.length; i++) {
        if (exp.startDate < this.expArr[i].startDate) {
          this.expArr.splice(i, 0, exp);
          console.log("after adding: " + JSON.stringify(this.expArr));
          return;
        }
      }
      console.log("after adding (at the end): " + JSON.stringify(this.expArr));
      this.expArr.push(exp);
    },
    organizeExpArr() {
      console.log("organizeExpArr()");
      // we sort by starting date
      this.expArr.sort((a, b) => {
        return a.startDate < b.startDate ? -1 : 1;
      });
      // fixing indexes
      for (let i = 0; i < this.expArr.length; i++) {
        this.expArr[i].id = i;
      }
    },
    editExperience(expId) {
      const expArrIndex = this.expArr.findIndex((exp) => exp.id === expId);
      if (expArrIndex < 0) {
        // todo: log to BE
        console.error("expArrIndex: exp not found");
        return;
      }
      this.experience = this.expArr[expArrIndex];
      this.dialogAddExperience = true;
    },
    deleteExperience(expId) {
      const expArrIndex = this.expArr.findIndex((exp) => exp.id === expId);
      if (expArrIndex < 0) {
        // todo: log to BE
        console.error("expArrIndex: exp not found");
        return;
      }
      if (
        confirm(
          `Are you sure you want to delete "${this.getCompanyName(
            this.expArr[expArrIndex]
          )}" experience?`
        )
      ) {
        // remove from expArr at expId index
        this.expArr.splice(expArrIndex, 1);
        this.organizeExpArr();
        this.setExperience();
      }
    },
    getCompanyName(exp) {
      if (exp == null) {
        return "Null company";
      }
      console.log("--- getCompanyName() ---");
      if (exp.selCompany != null && exp.selCompany.Name !== "") {
        console.log("1");
        return exp.selCompany.Name;
      }
      if (exp.manualCompanyName !== "") {
        console.log("2");
        return exp.manualCompanyName;
      }
      console.log("3");
      return "Unknown company";
    },
  },
};
</script>

<style scoped>
.main-card {
  width: 100vw;
  max-width: 1200px;
}
</style>
